module.exports = __webpack_public_path__ + "img/mbway.60f04c33.svg";